export type MessageData = { [key: string]: string };
export type Listener = (messageData: MessageData) => void;
type Listeners = { [key: string]: Listener[] };
export const listeners: Listeners = {};

export const addSilentNotificationListener = (messageType: string, listener: Listener) => {
    if (!listeners[messageType]) {
        listeners[messageType] = [];
    }
    listeners[messageType].push(listener);
};

export const removeSilentNotificationListener = (listener: Listener) => {
    Object.entries(listeners).forEach(([key, value]) => {
        listeners[key] = value.filter((aListener) => aListener !== listener);
    });
};
